import * as React from 'react';
import { Button, Form, Modal, Select } from 'antd';
import { Formik, FormikProps } from "formik";
import { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import { CustomerServiceQueries } from '../../../queries/customer-service-queries';

const { Option } = Select;

type Props = {
  isVisible: boolean,
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>,
  handleSubmit: Function,
  isLoading: boolean
}

const CreateDeletionRequestModal: React.FC<Props> = ({
  isVisible,
  setIsVisible,
  handleSubmit,
  isLoading
}) => {
  const formRef = useRef<FormikProps<any>>(null);
  const useGetCompanies = CustomerServiceQueries.useGetCompaniesThatCanBeDeleted();
 
  useEffect(() => {
    if (!isVisible) {
      formRef.current?.resetForm();
    }
  }, [isVisible]);

  return (
      <Formik
        innerRef={formRef}
        enableReinitialize
        initialValues={{
          companyId: null
        }}
        onSubmit={(val) => handleSubmit(val)}
        validationSchema={
          Yup.object().shape({
            companyId: Yup.number().required().typeError("Please select a company")
          })
        }
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue
        }) => {
          return (
            <Modal
              centered
              title="Request Deletion of Company"
              visible={isVisible}
              onCancel={() => setIsVisible(false)}
              footer={[
                <Button id="cancel" type="text" key="cancel" onClick={() => setIsVisible(false)}>
                  Cancel
                </Button>,
                <Button id={`submitButton`} type="primary" key="submit" htmlType="submit" form="createDeleteRequest" loading={isLoading} disabled={values.companyId === null}>
                  Submit
                </Button>
              ]}
              destroyOnClose
            >
              <p>Request the deletion of a company. This will need approval before it can be completed.</p>
              <Form
                id="createDeleteRequest"
                onFinish={handleSubmit}
                layout="vertical"
              >
                <Form.Item
                  label="Company"
                  help={(touched.companyId && errors.companyId ? errors.companyId : null)}
                  validateStatus={touched.companyId && errors.companyId ? 'error' : ''}
                  required
                >
                  <Select
                    value={values.companyId}
                    onChange={(value) => setFieldValue('companyId', value)}
                    onBlur={handleBlur('companyId')}
                    style={{ width: '100%' }}
                    placeholder="Select a company (Enter Company Id or Name to search)"
                    showSearch
                    filterOption={(input, option) => (option?.label as string)?.toLowerCase().includes(input.toLowerCase()) || (option?.value as number)?.toString().includes(input)}
                  >
                    {useGetCompanies.data?.map((company) => (
                      <Option key={company.id} value={company.id} label={company.name}>
                        {company.name} - {company.id}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Form>
            </Modal>
          )
        }}
      </Formik>
    )
};

export default CreateDeletionRequestModal;